import { Injectable } from '@angular/core';
import { GetAuthProfileResponse } from './authenticate.service';

export type ApiPermissionNode = GetAuthProfileResponse['data']['role']['permissions'][0];


@Injectable({
    providedIn: 'root'
})
export class PermissionService {
    private currentPermissions = new Set<string>();

    /**
     * 將 API 回傳的權限物件陣列，扁平化轉換成前端使用的 Set
     * API 格式: [{ functionName: 'device', canView: true, ... }]
     * 轉換結果: Set(['device_view', 'device_create', ...])
     *
     * @param apiPermissions 來自後端的權限物件陣列
     */
    setPermissions(apiPermissions: ApiPermissionNode[]): void {
        const flattenedKeys: string[] = [];

        apiPermissions.forEach(node => {
            // 根據 functionName (例如 'device', 'alarm') 組合出具體的權限 Key
            const baseFn = node.functionName;

            if (node.canView) flattenedKeys.push(`${baseFn}_view`);
            if (node.canCreate) flattenedKeys.push(`${baseFn}_create`);
            if (node.canEdit) flattenedKeys.push(`${baseFn}_edit`);
            if (node.canDelete) flattenedKeys.push(`${baseFn}_delete`);
            if (node.canViewReport) flattenedKeys.push(`${baseFn}_viewReport`);
            if (node.canDownload) flattenedKeys.push(`${baseFn}_download`);
        });

        this.currentPermissions = new Set(flattenedKeys);
    }

    /**
     * 檢查當前使用者是否具有特定權限
     * @param permission 權限碼
     * @returns boolean
     */
    hasPermission(permission: string): boolean {
        return this.currentPermissions.has(permission);
    }

    /**
     * 取得當前所有權限清單 (除錯或特定需求使用)
     * @returns string[]
     */
    getAllPermissions(): string[] {
        return Array.from(this.currentPermissions);
    }

    /**
     * 清除權限 (建議於登出時調用)
     */
    clearPermissions(): void {
        this.currentPermissions.clear();
    }
}
